import cn from 'classnames';
import {
  useState,
  useId,
  useEffect,
  forwardRef
} from 'react';

import removeBodyScroll from '../../util/removeBodyScroll.js';
import resetBodyScroll from '../../util/resetBodyScroll.js';

/*
  Mega menu modal is used in both the mega menu and the Utility nav search.
  This component can be used anywhere a MM style dropdown needs to appear below the header
*/
export default forwardRef(function MegaMenuModal({
  isOpen,
  children,
  onKeyDown = null,
  className = '',
}, ref) {
  const [topPos, setTopPos] = useState(0);
  const [leftPos, setLeftPos] = useState(0);
  const [maxHeight, setMaxHeight] = useState('');

  const megaId = useId();

  // We calc the top of the modal based on the position of the header
  // Header can be sticky or not sticky
  useEffect(() => {
    if (isOpen) {
      const header = document.querySelector('#header');
      const menuButtonTop = header.getBoundingClientRect().top;
      const menuButtonHeight = header.offsetHeight;
      const top = menuButtonTop + menuButtonHeight;
      const left = header.getBoundingClientRect().left;
      setTopPos(top);
      setLeftPos(left);
      // Set max height of the expandible content so it is scrollable if there is overflow
      setMaxHeight(`calc(100vh - ${top}px)`);
      removeBodyScroll();
    } else {
      resetBodyScroll();
    }
  }, [isOpen]);

  return (
    <>
      <div
        role="region"
        aria-hidden={!isOpen}
        className={cn(
          'lds-header-mega-menu-backdrop',
          {
            expanded: isOpen,
          },
          className
        )}
        style={{ top: topPos, left: leftPos }}
        id={megaId}
      >
      </div>

      <div
        ref={ref}
        className={cn(
          'mega-menu-wrapper',
          {
            expanded: isOpen,
          },
          className
        )}
        style={{ top: topPos, left: leftPos, maxHeight }}
        inert={isOpen ? null : ''}
        onKeyDown={onKeyDown}
      >
        <div
          className="mega-menu-expandible"
        >
          {children}
        </div>
      </div>
    </>
  );
});
